module.exports = __webpack_public_path__ + "media/images/nav_social/nav_youtube2-4ea0007a748e9fcded57bdc23c235c46.svg";